// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".border[data-v-49778938]{border-top:1px solid #e2e8f0}.crt__body[data-v-49778938]{background:#fff;padding:15px;font-family:\"Open Sans\";font-style:normal;font-weight:600;font-size:14px;line-height:21px;text-align:center;color:var(--clr-text)}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
